
const tp = window.tp || [];

tp.push( ['addHandler', 'customEvent', ( event ) => {

	if ( event.eventName === 'sendDataLayer' ) {

		if ( !event.params || !event.params.params ) {

			return;

		}

		let eventParams;
		try {

			eventParams = typeof event.params.params === 'string'
				? JSON.parse( event.params.params )
				: event.params.params;

		} catch ( e ) {

			return;

		}

		if ( eventParams && eventParams.action === 'start_process' ) {

			const eventData = {
				'event': 'cta_click',
				'cta': {
					'label': 'Zaczynamy proces',
					'type': 'button',
					'category': 'click'
				}
			};
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push( eventData );

		}

		if ( eventParams && eventParams.action === 'end_process' ) {

			const eventData = {
				'event': 'cta_click',
				'cta': {
					'label': 'Zacznij czytać',
					'type': 'button',
					'category': 'click'
				}
			};
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push( eventData );

		}

	}

}] );

document.addEventListener( 'DOMContentLoaded', () => {

	document.querySelectorAll( 'a[href="#aktywuj"]' ).forEach( link => {

		link.addEventListener( 'click', (  ) => {

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push( {
				'event': 'cta_click',
				'cta': {
					'label': 'Aktywuj dostęp!',
					'type': 'button',
					'category': 'click'
				}
			} );

		} );

	} );

} );
